<script setup lang="ts">
type Props = {
  height?: number;
  bgVariant?: string;
  barVariant?: string;
  max?: number;
  progress: number;
};

const props = defineProps<Props>();

const height = computed(() => {
  return props.height ? `h-[${props.height}px]` : 'h-[12px]';
});

const bg = computed(() => {
  return props.bgVariant ?? 'bg-texts/10';
});

const bar = computed(() => {
  return props.barVariant ?? 'bg-primary';
});

const progressPercent = computed(() => {
  const percent = (100 * props.progress) / (props.max || 100);

  return percent ? `${percent}%` : '0';
});
</script>

<template>
  <div :class="[$style.progressWrapper, height, bg]">
    <div
      :class="[$style.progressBar, bar]"
      :data-progress="progressPercent"
    ></div>
  </div>
</template>

<style module lang="postcss">
.progressWrapper {
  @apply w-full rounded-md overflow-hidden my-1;

  .progressBar {
    @apply h-[100%] relative;
    width: v-bind(progressPercent);
  }
}
</style>
